exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-stand {\n  width: 34px;\n  height: 34px;\n}\n", ""]);

// exports
